const DEFAULT_API_BASE_URL = "https://api.bellhopt.com/api/v1";

export function resolveApiBaseURL(env = process.env) {
  const configuredBaseURL = env.REACT_APP_API_BASE_URL?.trim();
  if (configuredBaseURL) return configuredBaseURL;

  return env.NODE_ENV === "development" ? "/api/v1" : DEFAULT_API_BASE_URL;
}

export { DEFAULT_API_BASE_URL };
